import React, { useState, useContext, useEffect} from 'react'
import { Container, Row, Col } from 'react-bootstrap';
import { Button } from '@material-ui/core';
import CatatanForm from './CatatanForm'
import AuthContext from '../../context/auth-context'
import { isArray } from 'util'
import validate from 'validate.js'
import DialogInfo from '../../Dialog/DialogInfo'
import mCatatan from './CatatanOrder.controller'

const CatatnOrderEdit = (props) => {
    const kodeoutlet = props.match.params.kodeoutlet;
    const kodebarang = props.match.params.kodebarang;
    const kodecatatan = props.match.params.kodecatatan
    const { clientID, token } = useContext(AuthContext)
    const [OpenConfirmInfo, setOpenConfirmInfo] = useState(false)
    const [dialogtext, setDialogtext] = useState()
    const [dialogUrl, setDialogUrl] = useState()
    const [isLoading, setIsLoading] = useState(false)
    const [state, setState] = useState(
        {
            kodecatatan: '',
            catatan: '',
            harga: 0,
        }
    )
    const validateForm = () => {
        const { catatan } = state;
        const promKategori = new Promise((resolve, reject) => {
            const constraint = {
                catatan: {
                    length: {
                        minimum: 3,
                        message: "catatan minimal terdiri dari 3 huruf"
                    },
                }
            }
            const validator = validate({ catatan }, constraint, { fullMessages: false });
            if (validator === undefined) {
                resolve();
            } else {
                reject(validator);
            }
        })
        return Promise.all([promKategori]);
    }
    const handleSimpan = () => {
        setIsLoading(true)
        validateForm().then(() => {
            setIsLoading(false)
            mCatatan.UpdateCatatan(kodeoutlet,kodebarang, kodecatatan , state.catatan,state.harga, clientID, token).then(resp => {
                if (resp) {
                    setOpenConfirmInfo(true)
                    setDialogtext(`<p>data berhasil di update<p/>`)
                    setDialogUrl(`/manajemenoutlet/${kodeoutlet}/catatan/${kodebarang}/1/5`)
                } else {
                    setOpenConfirmInfo(true)
                    setDialogtext(`<p>Gagal simpan data<p/>`)
                }
            }).catch(err => {
                setIsLoading(false)
                if (isArray(err) && err.length > 0) {
                    setOpenConfirmInfo(true)
                    setDialogtext(`<p>Gagal Simpan : ${err[0].message}<p/>`)
                } else if (typeof err == 'error') {
                    setOpenConfirmInfo(true)
                    setDialogtext(`<p>${err.message}<p/>`)
                } else {
                    console.log(err);
                }
            })
        }).catch(err => {
            setIsLoading(false)
            const keys = Object.keys(err);
            var errorMessage = "";
            for (const key of keys) {
                errorMessage += err[key] + "\n";
            }
            setOpenConfirmInfo(true)
            setDialogtext(`<p>${errorMessage}<p/>`)
        })
    }
    useEffect(() => {
        var render = true;
        if (kodeoutlet && kodecatatan) {
            mCatatan.getCatatan(kodeoutlet, kodecatatan, clientID, token).then(resp => {
                if (render) setState(resp);
            })
        }
        return () => {
            render = false;
        };
    }, [kodeoutlet, kodecatatan, clientID, token])
    const handleChange = (key, value) => {
        const newState = Object.assign({}, state);
        newState[key] = value;
        setState(newState);
    }

    return (
        <Container>
            <CatatanForm type="add" history={props.history} kodeoutlet={kodeoutlet} handleChange={handleChange} kodecatatan={state.kodecatatan} catatan={state.catatan} harga={state.harga} kodebarang={kodebarang} />
            <Row style={{ marginTop: 20, marginBottom: 20 }}>
                <Col xs={12} className="text-center">
                    <Button variant="contained" color="primary" onClick={handleSimpan} disabled={isLoading}>Update</Button>
                </Col>
            </Row>
            <DialogInfo open={OpenConfirmInfo} setOpen={setOpenConfirmInfo} text={dialogtext} url={dialogUrl} redirect={props.history.push} />
        </Container>
    )
}

export default CatatnOrderEdit;